<p-toast></p-toast>
<div class="card">
    <div class="p-fluid p-formgrid grid dropdown-card">

        <div class="field col-12 md:col-3">
            <label htmlFor="component">{{'APP_STATUS'| translate}}</label>
            <p-dropdown [options]="appStatusTypeList" appendTo="body" (onChange)="onSelectAppStatus()"
                [(ngModel)]="selectedAppStatus" placeholder="{{'SELECT'| translate}}" optionLabel="status_Description"
                [showClear]="true"></p-dropdown>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'SELECT_OUTLET_RD'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="contractorOutletList" [(ngModel)]="selectedOutletToGetData"
                    (onChange)="onSelectOutletToGetData()" appendTo="body"
                    placeholder="{{ 'SELECT_OUTLET_RD'| translate }}" optionLabel="Outlets"></p-dropdown>
            </div>
        </div>

        <div *ngIf="selectedOutletToGetData" class="field col-12 md:col-3">
            <label htmlFor="selectBenefitedArea">{{'BENEFITED_AREA_(IN_ACRE)'| translate}}</label>
            <div class="grid-item">
                <input type="text" class="readonly" readonly pInputText [(ngModel)]="selectedBenefitedAreaToGetData"
                    variant="filled" />
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'AGREEMENT_NO'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="agreementNoList" [(ngModel)]="agreementNoToGetData" appendTo="body"
                    (onChange)="onSelectAgreementNo()" placeholder="{{ 'SELECT_AGREEMENT_NO'| translate }}"
                    optionLabel="AgreementNo"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'CHUNK'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="chunkList" [(ngModel)]="chunkIdToGetData" appendTo="body"
                    (onChange)="onClickGetFarmerData()" placeholder="{{ 'SELECT_CHUNK'| translate }}"
                    optionLabel="combineData"></p-dropdown>
            </div>
        </div>

        <!-- <div class="field col-12 md:col-3">
            <label></label>
            <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="onClickGetFarmerData()" pButton pRipple
                    label="{{ 'Get Farmer Details' | translate }}" class="p-button-success"></button>
            </div>
            <div *ngIf="!hideGetDataButton" class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="onClickGetFarmerData()" pButton pRipple
                    label="{{ 'Get Farmer Details' | translate }}" class="p-button-success"></button>
            </div>

            <div *ngIf="hideGetDataButton" class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="clearGetData()" pButton pRipple label="{{ 'Clear Details' | translate }}"
                    class="p-button-help"></button>
            </div>
        </div> -->
    </div>

    <div *ngIf="chunkIdToGetData">
        <div class="dashboardTable mt-3">
            <p *ngIf="epcDataForApproval.length > 0"
                [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem', 'text-align': 'center'}">
                {{ 'Farmer
                Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}}
                {{
                agreementNoToGetData?.AgreementNo }}</p>
            <p-table #epcDataTable [value]="epcDataForApproval" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'APP_ID',
            'Applicant_type',
            'Name',
            'Father_name',
            'Aadhar_No',
            'Mobile',
            'PPP_ID',
            'MFMBNo',
            'TotalArea'
            ]" [rowHover]="true" dataKey="aadharNo"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="epcDataTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'S.No'| translate}}</th>
                        <th>{{'APP_ID'| translate}}</th>
                        <th>{{'TOTAL_AREA_ACRE'| translate}}</th>
                        <!-- <th>{{'APPLICANT_TYPE'| translate}}</th> -->
                        <th>{{'FARMER_NAME'| translate}}</th>
                        <th>{{'FATHERS_NAME'| translate}}</th>
                        <th>{{'AADHAR_NO'| translate}}</th>
                        <th>{{'MOBILE_NO'| translate}}</th>
                        <th>{{'PPP_ID'| translate}}</th>
                        <th>{{'MFMB_NO'| translate}}</th>
                        <th>{{'ACTION'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
                    <tr [style]="{'background-color': (product.SurveyStatus == 1)  ? 'rgb(200, 246, 221)' : 'rgb(249, 212, 212)'}">
                        <td>{{ i + 1 }}</td>
                        <td>{{product?.APP_ID}}</td>
                        <td>{{product?.TotalArea}}</td>
                        <!-- <td>{{product?.Applicant_type}}</td> -->
                        <td>{{product?.Name}}</td>
                        <td>{{product?.Father_name}}</td>
                        <td>{{product?.Aadhar_No}}</td>
                        <td>{{product?.Mobile}}</td>
                        <td>{{product?.PPP_ID}}</td>
                        <td>{{product?.MFMBNo}}</td>
                        <td>
                        <button *ngIf="product?.SurveyStatus == 0" pButton pRipple type="button" pTooltip="Action"
                            (click)="clickOnAppAction(product)" icon="pi pi-plus"
                            class="p-button-rounded p-button-text"></button>
                        <button *ngIf="product?.SurveyStatus == 1" pButton pRipple type="button" pTooltip="Edit-Estimation" icon="pi pi-pencil"
                            class="p-button-rounded p-button-text p-button-secondary"
                            (click)="clickOnEditApp(product)"></button>
                        </td>
                    </tr>
                    <!-- <tr *ngIf="expandedRows[product.landDetails]">
                    <td colspan="12">
                        <p-table [value]="product.landDetails" [rowHover]="true" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{'MORABBA_NUMBER'| translate}}</th>
                                    <th>{{'KILLA_NUMBER'| translate}}</th>
                                    <th>{{'Kanals'| translate}}</th>
                                    <th>{{'TOTAL_AREA'| translate}}</th>
                                    <th>{{'CROP'| translate}}</th>
                                    <th>{{'LAND_DOC'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-detail>
                                <tr>
                                    <td>{{detail?.morabbaNumber}}</td>
                                    <td>{{detail?.killaNumber}}</td>
                                    <td>{{detail?.kanals}}</td>
                                    <td>{{detail?.totalArea}}</td>
                                    <td>{{detail?.cropValue}}</td>
                                    <td>
                                        <a style="cursor: pointer" icon="pi pi-eye" [href]="detail?.landdoc_Path" target="_blank">
                                            <button pButton type="button"
                                                class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                                pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </td>
                </tr> -->
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">No Data found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="epcDataForApproval.length > 0" class="dashboardTable mt-5">
            <hr>
            <!-- <div class="dashboardTable mt-3"> -->
            <p *ngIf="epcDataForApproval.length > 0"
                [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem', 'text-align': 'center'}">
                {{ 'Estimation Details' | translate }}
            </p>
            <p-table #epcEstimationDataTable [value]="estimationDataForApproval" responsiveLayout="stack"
                [breakpoint]="'800px'" dataKey="id" editMode="row">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="epcEstimationDataTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:16.66%">{{ "PROGRAMME_NAME" | translate}}</th>
                        <th style="width:16.66%">{{ "CATEGORY_NAME" | translate}}</th>
                        <th style="width:16.66%">{{ "COMPONENT_NAME" | translate}}</th>
                        <th style="width:16.66%">{{ "SIZE" | translate}}</th>
                        <th style="width:16.66%">{{ "PER_UNIT_COST" | translate}}</th>
                        <th style="width:16.66%">{{ "QUANTITY" | translate}}</th>
                        <th style="width:16.66%">{{ "ACTUAL_QUANTITY" | translate}}</th>
                        <th style="width:16.66%">{{ "Remark" | translate}}</th>
                        <th style="width:16.66%">{{ "" | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="product"
                        [style]="{'background-color': (product.jeQuantity > 0 && product.jeQuantity <= product?.Quantity)  ? 'rgb(200, 246, 221)' : 'rgb(249, 212, 212)'}">
                        <td>{{product?.Program_Name}}</td>
                        <td>{{product?.category}}</td>
                        <td>{{product?.Component}}</td>
                        <td>{{product?.Size}}</td>
                        <td>{{product?.PerUnitCost}}</td>
                        <td>{{product?.Quantity}}</td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="number" [(ngModel)]="product.jeQuantity" required
                                        [ngClass]="{
                                        'ng-invalid ng-dirty': product.jeQuantity <= 0  || product.jeQuantity > product.Quantity}" />
                                    <div class="invalid-feedback" *ngIf="product.jeQuantity <= 0">
                                        {{'Greater than 0'| translate}}
                                    </div>
                                    <div class="invalid-feedback" *ngIf="product.jeQuantity > product.Quantity">
                                        {{'Not more than ' | translate}} {{product?.Quantity}}
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <input [style]="{'background-color': 'rgb(211, 209, 209)'}" readonly pInputText
                                        type="number" [ngModel]="product.jeQuantity" />
                                    <!-- {{product.price}} -->
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="product.jeRemarks" required
                                        [ngClass]="{
                                        'ng-invalid ng-dirty': product.jeRemarks == null || product.jeRemarks == undefined || product.jeRemarks == ''}" />
                                    <div class="invalid-feedback" *ngIf="product.jeRemarks == null || product.jeRemarks == undefined || product.jeRemarks == ''">
                                        {{'Non Empty.'| translate}}
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <input [style]="{'background-color': 'rgb(211, 209, 209)'}" readonly pInputText
                                        type="text" [ngModel]="product.jeRemarks" />
                                    <!-- {{product.price}} -->
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <div class="flex align-items-center justify-content-center gap-2">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onRowEditInit(product)"
                                    class="p-button-rounded p-button-text">
                                </button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    [disabled]="product.jeQuantity > product.Quantity" icon="pi pi-check" (click)="onRowEditSave(product)"
                                    class="p-button-rounded p-button-text p-button-success mr-2">
                                </button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onRowEditCancel(product, ri)"
                                    class="p-button-rounded p-button-text p-button-danger">
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="epcDataForApproval.length > 0" class="card submit-card mt-2">
            <div class="p-fluid p-formgrid grid">
                <!-- <div class="col-12 md:col-3">
                    <p-dropdown [options]="jeList" [(ngModel)]="selectedJE" placeholder="{{ 'Next User'| translate }}"
                        optionLabel="UserID" class="mr-3">
                    </p-dropdown>
                </div> -->
                <div class="col-12 md:col-3">
                    <p-dropdown [options]="items" [(ngModel)]="selectedStatus"
                        placeholder="{{ 'ACTION_TYPE'| translate }}" optionLabel="status" class="mr-3">
                    </p-dropdown>
                </div>
                <div class="col-12 md:col-3">
                    <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                        rows="3" cols="20" class="mr-3"></textarea>
                </div>
                <div class="col-12 md:col-3">
                    <button [disabled]="!selectedStatus" pButton pRipple label="Submit" (click)="onClickSubmit()"
                        class="p-button-success"></button>
                </div>
            </div>
        </div>
    </div>

</div>

<p-dialog header="Farmer Land Details" [baseZIndex]="-1000" [(visible)]="showActionDialog" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseActionDialog()">
    <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    programmeAppId}}</label></label>
        </div>

        <div class="field md:col-4 col-12">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeFarmerName |
                    uppercase}}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'PROG_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programName |
                    uppercase}}</label></label>
        </div>
    </div> -->

    <div class="card">
        <h6 [style]="{'font-weight': 'bold', 'color': 'black'}">{{'LAND_DETAILS' | translate}}</h6>
        <div *ngIf="epcDataForAppLandDetails && epcDataForAppLandDetails.length > 0" class="dashboardTable">
            <p-table [value]="epcDataForAppLandDetails" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'KILLA_NO' | translate}}</th>
                        <th>{{'MORABBA_NO'| translate}}</th>
                        <th>{{'LAND_DOC'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td class="surveyEstimateTable">{{product.Killa_No}}</td>
                        <td class="surveyEstimateTable">{{product.Morabba_No}}</td>
                        <td>
                            <a style="cursor: pointer" icon="pi pi-eye" [href]="product?.Land_Doc" target="_blank">
                                <button pButton type="button"
                                    class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                    pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>


    <div class="gps-coordinate-container">
        <div class="card">
            <h5>{{'CAPTURE_GPS_COORDINATES' | translate}}</h5>
            <div *ngIf="geoLocMulArray && geoLocMulArray.length>0 || overlays.length>0" class="dashboardTable">
                <ng-container *ngFor="let array of geoLocMulArray; let i = index">
                    <p-table [value]="array" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                        <ng-template pTemplate="caption">
                            <p>Table {{ i + 1}}</p>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{'CORNER_ID' | translate}}</th>
                                <th>{{'LATITUDE'| translate}}</th>
                                <th>{{'LONGITUDE'| translate}}</th>
                                <th *ngIf="geoLocMulArray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                            <tr>
                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                <td class="surveyEstimateTable">
                                    <button *ngIf="geoLocMulArray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate(rowIndex, i)"
                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <!-- <div class="flex align-items-center justify-content-between">
                                    {{'IN_TOTAL_THERE_ARE'| translate}} {{geolocationsarray ?
                                geolocationsarray.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                            </div> -->
                            <button *ngIf="geoLocMulArray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture(i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                class="p-button-info mr-2 mb-2"></button>
                            <button *ngIf="geoLocMulArray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon(i)" label="{{'Delete Polygon' | translate}}"
                                class="p-button-danger mr-2 mb-2"></button>

                            <button *ngIf="geoLocMulArray.length - 1 == i && geoLocMulArray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon(i)" label="{{'Create New Polygon' | translate}}"
                                class="p-button-warning mr-2 mb-2"></button>
                        </ng-template>
                    </p-table>
                </ng-container>
                <!-- <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays"></p-gmap> -->
                <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays" (onOverlayDragEnd)="onDrag($event)"></p-gmap>

            </div>
            <div class="my-2 proDataButton flex justify-content-center">
                <p class="invalid-feedback" *ngIf="geolocationsarray && geolocationsarray.length<4 && coordinateError">{{coordinateError | translate}}</p>
                <!-- <button pButton pRipple type="submit" (click)="onCapture()" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                    class="p-button-info mr-2 mb-2"></button> -->
                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation()" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                    class="p-button-secondary mr-2 mb-2"></button>
            </div>

        </div>
        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-4 col-12 area-display-card">
                <label>{{'APPLIED_LAND_AREA_(ACRES)'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{surveyArea}}</label></label>
            </div>
            <div *ngIf="landArea > 0" class="field md:col-4 col-12 area-display-card">
                <label>{{'CALCULATED_SURVEY_AREA_(ACRES)'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{landArea | number : '1.2-2'}}</label></label>
            </div>
        </div>
        <div *ngIf="landArea > 0 && (landArea - surveyArea > 0.1*landArea || surveyArea - landArea > 0.1*landArea)" class="p-fluid p-formgrid justify-content-center areaError mb-4" style="display: flex; flex-wrap:wrap">
            <p>{{ "CALCULATED_AREA_IS_MUCH_GREATER_THAN_APPLIED_AREA._PLEASE_RECAPTURE_THE_COORDINATES" | translate }}</p>
        </div>
    </div>

    <div class="card block md:hidden">
        <h5>{{'CAPTURE_IMAGE'| translate}}</h5>
        <div class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}"
                    optionLabel="name" [showClear]="true"></p-dropdown>
    
            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}" [disabled]="!selctedFileType"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="word-break: break-word;display: flex;
                                justify-content: space-between">
                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i>
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block; width:200px">
                            </div>
                            <!-- <div class="description">
                                <span>
                                    {{item.displayName}}
                                    <br>
                                    <p style="margin-bottom: 0;" *ngIf="item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 0;" *ngIf="!item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                </span>
                            </div> -->
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)" class="video-align"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}" class="p-button-success m-2"
                        (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog>
    </div>


    <div class="card hidden md:block">
        <h5>{{'CAPTURE_IMAGE'| translate}}</h5>
        <div class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}"
                    optionLabel="name" [showClear]="true"></p-dropdown>
    
            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}" [disabled]="!selctedFileType"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="display: flex; justify-content: space-between">
                                    <!-- {{item.displayName}} -->
                                    
                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i>
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block;">
                            </div>
                            <!-- <div class="description">
                                <span>
                                    {{item.displayName}}
                                    <br>
                                    <p style="margin-bottom: 0;" *ngIf="item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 0;" *ngIf="!item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                </span>
                            </div> -->
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}" class="p-button-success m-2"
                        (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog>
    </div>   
    <button pButton pRipple type="button" label="{{'SUBMIT'| translate}}" class="p-button-success m-2" style="float: right;"
        (click)="submitFarmerPVSurvey()"></button>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>